import { formatPhoneNumber } from 'src/utils/formatters/formatPhoneNumber';
import { PhoneConfiguration } from '../types';

export const NON_DIGITS = /[^\d]/g;

export const getPhoneNumber = (phoneNumber: string): PhoneConfiguration => {
    const digitsOnly = phoneNumber.replace(NON_DIGITS, '');
    return {
        asLink: `tel:+1${digitsOnly}`,
        formatted: formatPhoneNumber(digitsOnly) as string,
    };
};
